<template>
  <div class="indexador">
    <p>Trámite N°: <strong>{{ idTramite }}</strong></p>
    <button @click="ejecutarIndexador" :disabled="ejecutando">
      {{ ejecutando ? 'Indexando...' : 'Indexar PDFs' }}
    </button>

    <!-- Consola de salida -->
    <div v-if="lineas.length > 0" class="consola">
      <p v-for="(linea, i) in lineas" :key="i" :class="claseLinea(linea)">
        {{ linea }}
      </p>
    </div>

    <!-- Estado final -->
    <div v-if="estadoFinal" :class="estadoFinal === 'COMPLETADO' ? 'exito' : 'error'">
      {{ estadoFinal === 'COMPLETADO' ? '✅ Indexación completada' : '❌ Error en indexación' }}
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import Swal from 'sweetalert2'

const route = useRoute()
const idTramite = ref(null)
const lineas = ref([])
const ejecutando = ref(false)
const estadoFinal = ref(null)
let eventSource = null

onMounted(() => {
  idTramite.value = route.params.p_idtramite
})

onUnmounted(() => {
  if (eventSource) eventSource.close()
})

function ejecutarIndexador() {
  lineas.value = []
  estadoFinal.value = null
  ejecutando.value = true
  let finalizado = false

  eventSource = new EventSource(
    `http://localhost:8080/api/v1/indexador/ejecutar/${idTramite.value}`
  )

  eventSource.onmessage = (event) => {
    lineas.value.push(event.data)
  }
    console.log('>>> evento fin recibido 1:', event.data)

  eventSource.addEventListener('fin', (event) => {
    console.log('>>> evento fin recibido 2:', event.data)
    finalizado = true
    estadoFinal.value = event.data
    ejecutando.value = false
    eventSource.close()

    if (event.data === 'COMPLETADO') {
      Swal.fire({
        icon: 'success',
        title: 'Indexación completada',
        text: `Trámite ${idTramite.value} procesado correctamente`,
        confirmButtonText: 'Aceptar'
      })
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error en indexación',
        text: `Ocurrió un error al procesar el trámite ${idTramite.value}`,
        confirmButtonText: 'Aceptar'
      })
    }
  })

  eventSource.addEventListener('error', () => {
    if (finalizado) return
    estadoFinal.value = 'ERROR'
    ejecutando.value = false
    eventSource.close()

    Swal.fire({
      icon: 'error',
      title: 'Error de conexión',
      text: 'No se pudo conectar con el servidor',
      confirmButtonText: 'Aceptar'
    })
  })
}

function claseLinea(linea) {
  if (linea.includes('Error') || linea.includes('ERROR')) return 'linea-error'
  if (linea.includes('===')) return 'linea-separador'
  if (linea.includes('100%') || linea.includes('terminado')) return 'linea-exito'
  return 'linea-normal'
}
</script>

<style scoped>
.consola {
  background: #1e1e1e;
  color: #d4d4d4;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  padding: 16px;
  border-radius: 6px;
  margin-top: 12px;
  max-height: 400px;
  overflow-y: auto;
}
.linea-normal    { color: #d4d4d4; }
.linea-separador { color: #569cd6; font-weight: bold; }
.linea-exito     { color: #4ec9b0; }
.linea-error     { color: #f44747; }
.exito { color: green; margin-top: 10px; font-weight: bold; }
.error { color: red;   margin-top: 10px; font-weight: bold; }
</style>